import { Content } from '@prismicio/client';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import clsx from 'clsx';
import blogStyles from '@/styles/blog.module.css';

/**
 * Props for `RichText`.
 */
export type RichTextProps = SliceComponentProps<Content.RichTextSlice>;

/**
 * Component for "RichText" Slices.
 */
const RichText = ({ slice }: RichTextProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-[#0E1110] text-white w-full flex flex-col items-center py-36"
    >
      <div className={clsx('text-white', blogStyles.blogPost)}>
        <PrismicRichText field={slice.primary.title} />
        <PrismicRichText field={slice.primary.rich_text} />
      </div>
    </section>
  );
};

export default RichText;
